export default __webpack_public_path__ + "static/media/booked.304f5195.svg";